import PuntoDeVenta from "./PuntoDeVenta";

export default PuntoDeVenta;
